// Menampilkan gambar penuh (tanpa crop) di dalam frame tetap.
// Area kosong diisi versi blur dari gambar yang sama agar rapi.
export function CoverImage({ src, alt = "", className = "", imgClassName = "" }) {
  if (!src) return <div className={`bg-slate-100 ${className}`} data-testid="cover-image-empty" />;
  return (
    <div className={`relative overflow-hidden bg-slate-100 ${className}`} data-testid="cover-image">
      <img src={src} alt="" aria-hidden="true" className="absolute inset-0 w-full h-full object-cover scale-110 blur-xl opacity-50" />
      <img src={src} alt={alt} className={`relative z-[1] w-full h-full object-contain ${imgClassName}`} />
    </div>
  );
}
